import { AppConfigService } from './app-config.service';

export function initializeAppConfig(appConfigService: AppConfigService) {
  return () => appConfigService.load();
}
